import { Component, Injector } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { ShareServices, ShareWrapper } from './modules/share/share-wrapper.component';

@Component({
    selector: 'share-root',
    templateUrl: './share.app.component.html',
    styleUrls: ['./share.app.component.scss'],
    standalone: true,
    imports: [RouterOutlet],
})
export class ShareAppComponent extends ShareWrapper<ShareAppComponent> {
    constructor(
        injector: Injector
    ) {
        super();
        ShareServices.initialize(injector)
    }
}
